import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../auth/auth-services/auth-guard.service";
import { ConfirmNewArticleComponent } from "./confirm-new-article/confirm-new-article.component";
import { ListArticlesComponent } from "./list-articles/list-articles.component";
import { NewArticleComponent } from "./new-article/new-article.component";
import { PageListBlogComponent } from "./page-list-blog/page-list-blog.component";
import { SingleArticleComponent } from "./single-article/single-article.component";

const blogRoutes: Routes = [
    { path: 'blog', component: PageListBlogComponent },
    { path: 'blog/new', canActivate:[AuthGuard], component: NewArticleComponent },
    { path: 'blog/new/confirm', component: ConfirmNewArticleComponent },
    { path: 'blog/:id', component: SingleArticleComponent }
];

@NgModule({
    imports: [
        RouterModule.forChild(blogRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class BlogRoutingModule { }
